import { twMerge } from 'tailwind-merge';

/* 商品卡片 */
type cardProps = Partial<{
  className?: string;
  horizontal?: boolean;
  style?: any;
  animation?: boolean;
  viewRef?: any;
}>;

const BrandCardSkeleton = (props: cardProps) => {
  const { style, viewRef, className } = props;

  return (
    <div
      ref={viewRef}
      style={style}
      className={twMerge('w-[180px] brand-card-shadow rounded-500 overflow-hidden pb-2', className)}>
      <div className="relative">
        <div className="grid grid-rows-2 grid-cols-2 gap-[1px]">
          {new Array(4).fill(0).map((item, index) => {
            return <div key={index} className="w-[90px] h-[90px] bg-surface-200-bg"></div>;
          })}
        </div>
        <div className="absolute left-2.5 -bottom-5 w-12 h-12 rounded-full brand-card-shadow bg-surface-100-bg"></div>
      </div>
      <div>
        <div className="mt-[30px] w-20 ml-2 h-4 rounded-400 bg-surface-200-bg"></div>
        <div className="mt-1 w-10 h-4 ml-2 rounded-400 bg-surface-200-bg"></div>
      </div>
    </div>
  );
};

export default BrandCardSkeleton;
